import Flow from 'types/Flow';

import { FINAL_INSTRUCTIONS } from '../../common';
import { isVisibleStep } from '../../utils';
import { COMMON_ON_SITE_KIOSK_CHECKIN_STEPS, CommonOnSiteKioskCheckInSteps, VEHICLE_CHECK_QR_CODE } from '../onSite';

import type { SelfServiceStep } from '../../../types';

export type CommonKioskCheckInSteps = CommonOnSiteKioskCheckInSteps;

export const COMMON_KIOSK_CHECK_IN_STEPS: Flow<CommonKioskCheckInSteps> = COMMON_ON_SITE_KIOSK_CHECKIN_STEPS;

export const COMMON_KIOSK_VEHICLE_CHECK_QR_CODE: SelfServiceStep = {
  ...VEHICLE_CHECK_QR_CODE,
  next: FINAL_INSTRUCTIONS.key,
  data: {
    ...VEHICLE_CHECK_QR_CODE.data,
    isVisible: (selfService, config) => isVisibleStep(VEHICLE_CHECK_QR_CODE, selfService, config),
  },
};
